var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState, useContext, useMemo } from 'react';
import { services } from '../../../shared';
import './client-applicants.scss';
import { ClientDetails } from '../client-details/client-details';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import { useLoader } from '../../../shared/utils';
export var ClientApplicants = function (_a) {
    var _b;
    var caseDetails = _a.caseDetails, onUpdate = _a.onUpdate, showUploadModal = _a.showUploadModal, reloadUpdate = _a.reloadUpdate, customerTypeId = _a.customerTypeId, customerName = _a.customerName;
    var data = useContext(LoaderContext);
    var isLoading = useMemo(function () { return data.isLoading; }, [data.isLoading]);
    var _c = useState(), modalVisible = _c[0], setModalVisible = _c[1];
    var _d = useState(), documents = _d[0], setDocuments = _d[1];
    var caseApplicantDocumentsSetIsLoading = useLoader({ identifier: 'caseApplicantDocuments' }).caseApplicantDocumentsSetIsLoading;
    var fetchDocuments = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var docs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCustomerDocuments(id)];
                case 1:
                    docs = (_a.sent()).data;
                    return [2 /*return*/, docs];
            }
        });
    }); };
    var loadDocumentGrid = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
        var docs, docsCopy;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    caseApplicantDocumentsSetIsLoading(true);
                    return [4 /*yield*/, fetchDocuments(customerId)];
                case 1:
                    docs = _a.sent();
                    docsCopy = new Map();
                    docsCopy.set(customerId, docs);
                    caseApplicantDocumentsSetIsLoading(false);
                    setDocuments(docsCopy);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            (_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _a === void 0 ? void 0 : _a.forEach(function (a) {
                loadDocumentGrid(a.customerId);
            });
            return [2 /*return*/];
        });
    }); };
    var deleteDocument = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm('Are you sure you wish to delete this document?')) return [3 /*break*/, 2];
                    id = Number(e.currentTarget.getAttribute('data-value'));
                    return [4 /*yield*/, services.deleteCustomerDocument(id)];
                case 1:
                    _a.sent();
                    loadDocumentGrid(id);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchData();
    }, [caseDetails, reloadUpdate]);
    var caseApplicantsWithLoader = useMemo(function () {
        var _a;
        return isLoading
            ? [{ isMainApplicant: true }, { isMainApplicant: false }]
            : (_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) !== null && _a !== void 0 ? _a : [];
    }, [caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants, isLoading]);
    return (React.createElement("div", { className: "case-applicants" },
        (caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 : caseApplicantsWithLoader.length) > 0 &&
            ((_b = caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 : caseApplicantsWithLoader.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement(ClientDetails, { applicant: __assign(__assign({}, caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 : caseApplicantsWithLoader.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })[0]), { customerTypeId: customerTypeId, customerName: customerName }), documentList: documents === null || documents === void 0 ? void 0 : documents.get((caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 : caseApplicantsWithLoader.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })[0]).customerId), fetchData: fetchDocuments, showUploadModal: showUploadModal, modalVisible: modalVisible, deleteDocument: deleteDocument, onUpdate: onUpdate })), caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 :
        caseApplicantsWithLoader.filter(function (a) { return !a.isMainApplicant; }).map(function (doc, index) { return (React.createElement("div", { key: doc.customerId, className: "c-non-main" },
            React.createElement(ClientDetails, { key: doc.customerId, applicant: caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 : caseApplicantsWithLoader.filter(function (a) { return a.customerId === doc.customerId; })[0], documentList: documents === null || documents === void 0 ? void 0 : documents.get(caseApplicantsWithLoader === null || caseApplicantsWithLoader === void 0 ? void 0 : caseApplicantsWithLoader.filter(function (a) { return a.customerId === doc.customerId; })[0].customerId), index: index + 1, fetchData: fetchDocuments, showUploadModal: showUploadModal, modalVisible: modalVisible, deleteDocument: deleteDocument, onUpdate: function () { } }))); })));
};
